@if (isAuthenticated$ | async) {
  <ul class="navbar-nav">
    <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-end" autoClose="outside">
      <button
        type="button"
        class="btn nav-link text-white preferences-toggle"
        ngbDropdownToggle
        i18n-aria-label
        aria-label="Preferences"
        i18n-title
        title="Preferences"
      >
        <i class="fa fa-sliders-h"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-menu preferences-menu">
        <h6 class="dropdown-header" i18n>Preferences</h6>
        <app-language-select></app-language-select>
        @if (hasMenus()) {
          <app-currency-select></app-currency-select>
        }
        @if (showAppearance()) {
          <div class="dropdown-divider"></div>
          <app-appearance-menu></app-appearance-menu>
        }
      </div>
    </li>
  </ul>
}
